import { EditSettingsAction } from '@leverege/molten/data-viewers'

import ShelfMonitoringEditor from './ShelfMonitoringEditor'

export default new EditSettingsAction( {
  id : 'petsmart.dataViewers.shelf.ShelfCardDataViewer',
  matches : { use : 'actionBar', client : 'ShelfMonitoringDataViewer' },
  editor : ShelfMonitoringEditor,
  title : 'Shelf Monitoring Editor',
  versionType : 'shelfMonitoring',
  editorProps : ( opts ) => {
    const { delegate, objectType, blueprint, relationship } = opts.context?.clientProps || {}
    return { delegate, objectType, blueprint, relationship }
  }
} )
